import api from "./config/axiosWith401Redirect";

const COUPON_URL = "/coupon";

export const verifyCoupon = async (coupon) => {
  const response = await api.post(`${COUPON_URL}/verfiy/`, coupon);
  return response.data;
};
